import { CostCenter } from "@/interfaces/costCenter";
import { CustomAxiosRequestConfig } from "@/interfaces/customAxiosRequestConfig";
import { Department } from "@/interfaces/department";
import axios from "@/lib/axios";
import { useQuery } from "@tanstack/vue-query";
import { get } from "@vueuse/core";
import { MaybeRef, ref, watch } from "vue";

interface Props {
  params: Params;
  immediate?: boolean;
}

interface Params {
  id: MaybeRef<number | undefined>;
}

const getCostCenters = async ({ id }: Params): Promise<CostCenter[] | void> => {
  if (!get(id)) return;

  const { data } = await axios.get<CostCenter[]>(
    `/api/departments/${get(id)}/costcenters`,
    { errorHandling: false } as CustomAxiosRequestConfig,
  );

  return data;
};

const useDepartmentCostCenters = (props: Props) => {
  const { immediate, params } = props;
  const departameniId = ref<undefined | number>();
  // const { id } = params;

  const { data, isLoading, isFetching, isError, refetch } = useQuery(
    ["department"],
    () =>
      getCostCenters({
        id: params.id || departameniId,
      }),
    {
      enabled: immediate,
    },
  );

  return {
    costCenters: data,
    isError,
    isLoading,
    isFetching,
    departameniId,

    refetch,
  };
};

export default useDepartmentCostCenters;
